import { FormDeliveryStatus } from "interfaces/FormDeliveryStatus";

export const checkIfFrozen = (status: FormDeliveryStatus, canEdit: boolean) => {
	return status === "pendingValidation" || status === "validated" || !canEdit;
};
